import React from "react";
import CmsContentPage from "../components/CmsContentPage";

/**
 * Primary: GET …/public?limit=5&page=1&slug=privacy-policy
 * Fallback: privacy_policy for legacy CMS rows.
 */
const PRIVACY_SLUGS = Object.freeze(["privacy-policy", "privacy_policy"]);

/**
 * Privacy Policy — API slug `privacy-policy` (ChillnPark CMS seed).
 */
export default function PrivacyPolicy() {
  return (
    <CmsContentPage
      slugCandidates={PRIVACY_SLUGS}
      pageLabel="Privacy Policy"
      emptyMessage="Privacy policy content has not been published yet."
    />
  );
}
